import React from "react"

export const LoadingToast = (props) => {
	return (
		<div
			style={{
				...(props.position === "relative"
					? { position: "relative" }
					: { position: "fixed", bottom: "0.94rem", zIndex: "500" }),
				width: "100%",
				display: "flex",
				justifyContent: "center",
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: "0.5rem",
					background: "#fff",
					borderRadius: "1rem",
					padding: "0.5rem 1rem",
					border: "1px solid #ccc",
					boxShadow:
						"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
				}}
			>
				<Loader />
				<span style={{ color: "#555" }}>{props.children}</span>
			</div>
		</div>
	)
}

export const Loader = ({ size = "1rem", color = null }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			style={{ ...(color ? { color } : {}) }}
		>
			<g>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					opacity=".14"
				></rect>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					opacity=".29"
					transform="rotate(30 12 12)"
				></rect>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					opacity=".43"
					transform="rotate(60 12 12)"
				></rect>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					opacity=".57"
					transform="rotate(90 12 12)"
				></rect>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					opacity=".71"
					transform="rotate(120 12 12)"
				></rect>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					opacity=".86"
					transform="rotate(150 12 12)"
				></rect>
				<rect
					width="2"
					height="5"
					x="11"
					y="1"
					fill="currentColor"
					transform="rotate(180 12 12)"
				></rect>
				<animateTransform
					attributeName="transform"
					calcMode="discrete"
					dur="0.75s"
					repeatCount="indefinite"
					type="rotate"
					values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
				></animateTransform>
			</g>
		</svg>
	)
}
